import React from 'react';
import { PaypalPriceMessaging } from '@thd-olt-component-react/paypal-checkout-button';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import PropTypes from 'prop-types';
import { usePartsAndServices } from '../PartsAndServicesProvider';

const reduceUnitPricesCallback = (acc, item) => ((item ? Number(item.price || 0) : 0) + acc);

export const PayPalMessage = () => {
  const {
    haulAwaySelections,
    installationSelections,
    protectionSelections,
    productsMap
  } = usePartsAndServices();

  const theme = useTheme(PayPalMessage);
  const { hidePaypal } = theme.props;

  const { isExchangeCustomer } = useThdCustomer() || {};
  const isPaypalEnabled = useConfigService('PAYPAL_ENABLE');
  const isPaypalPayInFour = useConfigService('paypalPayInFour');

  if (!productsMap || isExchangeCustomer || !isPaypalEnabled || !isPaypalPayInFour || hidePaypal) return null;

  const haulAwayTotal = Object.values(haulAwaySelections)
    .reduce((acc, itemSelections) => {
      return acc + itemSelections.reduce(reduceUnitPricesCallback, 0);
    }, 0);
  const protectionTotal = Object.values(protectionSelections).reduce(reduceUnitPricesCallback, 0);
  const installationTotal = Object.values(installationSelections)
    .reduce((acc, itemSelections) => {
      return acc + itemSelections.reduce(reduceUnitPricesCallback, 0);
    }, 0);

  const totalItemPrice = [...productsMap.values()].reduce((total, { pricing = {} } = {}) => {
    const { value, original } = pricing || {};
    return total + Number((value || original));
  }, 0);

  const totalPrice = Number.parseFloat((
    totalItemPrice
    + protectionTotal
    + installationTotal
    + haulAwayTotal
  )).toFixed(2);

  return (
    <section className="sui-mb-4">
      <PaypalPriceMessaging
        payInFour
        orderTotal={totalPrice}
        fromPage="P&S"
        fontSize="16"
      />
    </section>
  );
};

PayPalMessage.displayName = 'PayPalMessage';

PayPalMessage.themeProps = {
  hidePaypal: PropTypes.bool
};

PayPalMessage.defaultThemeProps = {
  hidePaypal: false
};
